import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddOurTeam from "./AddOurTeam";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import { toast } from "react-toastify";
// import AddLeadershipCouncil from "./AddLeadershipCouncil";

const OurTeam = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getList();
  }, []);

  const getList = (keyword: string = "") => {
    WebService.getAPI({
      action: `our-team/getTeamMembers?keyword=${keyword}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        console.log("l;og", perm)
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });

        for (let i in res?.data?.data) {
          const row = res.data.data[i];
          row.originalImage = row.image;
          row.image = (
            <img
              src={row.image}
              alt={row.name}
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          );

          row.action = (
            <div>
              {perm.canEdit && (
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddLeadershipCouncil(true);
                    setLeadershipCouncilToEdit(row);
                  }}
                />
              )}

              {perm.canDelete && (
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(row._id)}
                />
              )}
            </div>
          );
        }

        setTeamMembers(res?.data?.data);
        // const total = res.data.total; // ✅ total count of members
        // const currentPage = res.data.page; // ✅ current page
        // const totalPages = res.data.pages;
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => { });
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };
  const handleReorder = (newRows: any) => {
    setTeamMembers(newRows);

    const reorderedPayload = newRows.map((item: any, index: number) => ({
      _id: item._id,
      order_by: index + 1,
    }));

    WebService.postAPI({
      action: "our-team/update-order",
      body: reorderedPayload,
    })
      .then(() => { })
      .catch(() => {
        toast.error("Failed to update order");
      });
  };
  return (
    <>
      <AddOurTeam
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getList(searchRef.current);
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.putAPI({
              action: `our-team/deleteTeamMember/${leadershipCouncilToDelete}`,
              body: {},
            }).then(() => {
              setShowDeleteModal(false);
              getList(searchRef.current);
            });
          }
        }}
        message="Are you sure you want to delete this team member?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Our Team</div>
            {pagePermission.canAdd && (
              <CustomButton
                isLoading={false}
                label="Add"
                onClick={() => {
                  setLeadershipCouncilToEdit(null);
                  setShowAddLeadershipCouncil(true);
                }}
                style={{ width: 100 }}
              />)}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;                  
                  setSearch(value);
                  getList(searchRef.current);
                }}
              />
            </div>
          </div>
          <CustomTableSortable
            columns={[
              {
                id: "image",
                label: "Image",
                minWidth: 100,
                align: "center",
              },
              { id: "name", label: "Name", minWidth: 100, align: "center", },
              {
                id: "designation",
                label: "Designation",
                minWidth: 100,
                align: "center",
              },

              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={teamMembers}
            totalCount={0}
            currentPage={1}
            pageSize={10}
            onPageChange={() => { }}
            draggable // 👈 enable drag
            onRowsReorder={handleReorder} // 👈 handle dropping
            pagination={false}
          />
        </Card>
      </div>
    </>
  );
};

export default OurTeam;
